import { render, staticRenderFns } from "./DaifaGuide.vue?vue&type=template&id=2668b74e&scoped=true&"
import script from "./DaifaGuide.vue?vue&type=script&lang=js&"
export * from "./DaifaGuide.vue?vue&type=script&lang=js&"
import style0 from "styles/views/index/daifaguide.css?vue&type=style&index=0&id=2668b74e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2668b74e",
  null
  
)

export default component.exports